import { EXPORT_TRUNCATE_LEGEND_LENGTH } from '@core/reports-types';
import { unicodeStringLength, truncateUnicodeString } from '@core/utils-legacy';

export const truncateReportsLabel = <T>(label: T, length = EXPORT_TRUNCATE_LEGEND_LENGTH): T => {
  if (typeof label !== 'string') {
    return label;
  }
  const labelLength = unicodeStringLength(label);
  if (labelLength <= length) {
    return label;
  }

  return <T>`${truncateUnicodeString(label, length)}...`;
};
